import { useContext } from 'react'
import type { UseQueryOptions } from '@tanstack/react-query'
import { useQuery } from '@tanstack/react-query'

import GeoContext from 'contexts/geoContext'
import type { ExploreOfferParams } from 'tripPlanner/api/explore/offers'
import { getExploreOffers } from 'tripPlanner/api/explore/offers'
import type {
  GetExploreOffersResponse,
  GetExploreOffersError,
  ExploreOffersList,
} from 'tripPlanner/api/explore/types'

const MINUTES = 60 * 1000
const STALE_TIME = 5 * MINUTES

export type UseExploreOffersParams = {
  bounds?: string
  region?: string
  offerTypes?: string
}

function paramsHaveBounds(
  params: UseExploreOffersParams,
): params is ExploreOfferParams {
  return Boolean(params.bounds)
}

export const useExploreOffers = (
  params: UseExploreOffersParams,
  options?: UseQueryOptions<
    GetExploreOffersResponse['result'],
    GetExploreOffersError,
    ExploreOffersList
  >,
) => {
  const { currentRegionCode } = useContext(GeoContext)
  const region = params.region ?? currentRegionCode

  return useQuery({
    queryKey: ['tripExplore', 'hotels', params.bounds, region, params.offerTypes] as const,
    queryFn: () =>
      paramsHaveBounds(params)
        ? getExploreOffers({ ...params, region })
        : Promise.resolve({ offers: [], total: 0 }),
    staleTime: STALE_TIME,
    enabled: paramsHaveBounds(params),
    ...options,
  })
}
